import React from 'react';
import { useNavigate } from 'react-router-dom';
const ROUTES = [
  { from:'JFK', to:'LAX', fromCity:'New York',      toCity:'Los Angeles',  col:'from-emerald-700 to-green-600'  },
  { from:'ORD', to:'MIA', fromCity:'Chicago',       toCity:'Miami',        col:'from-amber-600 to-yellow-500'   },
  { from:'DFW', to:'LAS', fromCity:'Dallas',        toCity:'Las Vegas',    col:'from-emerald-800 to-emerald-600'},
  { from:'SFO', to:'SEA', fromCity:'San Francisco', toCity:'Seattle',      col:'from-green-700 to-emerald-500'  },
  { from:'BOS', to:'MCO', fromCity:'Boston',        toCity:'Orlando',      col:'from-amber-700 to-amber-500'    },
  { from:'ATL', to:'JFK', fromCity:'Atlanta',       toCity:'New York',     col:'from-emerald-600 to-teal-600'   },
  { from:'LAX', to:'HNL', fromCity:'Los Angeles',   toCity:'Honolulu',     col:'from-teal-700 to-cyan-600'      },
  { from:'IAH', to:'DEN', fromCity:'Houston',       toCity:'Denver',       col:'from-green-800 to-green-600'    },
];
export default function PopularRoutes() {
  const navigate = useNavigate();
  const today = new Date().toISOString().split('T')[0];
  return (
    <section className="py-12 sm:py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-10">
          <span className="inline-block text-xs font-bold text-emerald-700 uppercase tracking-widest bg-emerald-50 border border-emerald-100 px-4 py-1.5 rounded-full mb-3">Popular Routes</span>
          <h2 className="text-3xl sm:text-4xl font-black text-gray-900 mb-2">Popular Travel Routes</h2>
          <p className="text-gray-500 text-sm sm:text-base max-w-xl mx-auto">Travelers frequently request assistance for these routes. Route availability, schedules, and pricing may vary depending on travel dates, airline inventory, and market conditions.</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
          {ROUTES.map(r => (
            <div key={r.from+r.to}
              onClick={() => navigate('/flights?origin='+r.from+'&destination='+r.to+'&date='+today+'&adults=1&tripType=oneway&class=economy&passengers=1')}
              className={'group bg-gradient-to-br '+r.col+' rounded-2xl p-5 text-white cursor-pointer hover:shadow-2xl hover:-translate-y-1 transition-all duration-300'}>
              <div className="flex items-center justify-between mb-3">
                <div><p className="text-2xl font-black">{r.from}</p><p className="text-white/70 text-xs">{r.fromCity}</p></div>
                <div className="flex items-center gap-1 flex-1 mx-3">
                  <div className="h-px flex-1 bg-white/30"/>
                  <span className="text-base">✈</span>
                  <div className="h-px flex-1 bg-white/30"/>
                </div>
                <div className="text-right"><p className="text-2xl font-black">{r.to}</p><p className="text-white/70 text-xs">{r.toCity}</p></div>
              </div>
              <div className="pt-3 border-t border-white/20 flex justify-between items-center">
                <span className="text-white/70 text-xs">Check availability</span>
                <span className="bg-white/15 border border-white/20 text-white text-xs font-bold px-3 py-1 rounded-xl group-hover:bg-white group-hover:text-emerald-700 transition-all">Search →</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
